import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LayoutService {
  private isSmallScreenSubject = new BehaviorSubject<boolean>(window.innerWidth < 576);
  isSmallScreen$ = this.isSmallScreenSubject.asObservable();
  private isSidebarHovered = new BehaviorSubject<boolean>(false);
  isSidebarHovered$ = this.isSidebarHovered.asObservable();
  isSidebarOpen = false;
  constructor() {
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }

  toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
    this.checkScreenSize();
  }

  closeSidebar(): void {
    if(this.isSidebarOpen){
      this.isSidebarOpen = !this.isSidebarOpen;
      this.checkScreenSize();
    }
  }

  checkScreenSize(): void {
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    const adjustedWidth = window.innerWidth - scrollbarWidth;
    const isSmall = adjustedWidth < 768;
    this.isSmallScreenSubject.next(isSmall);
  }
  setSidebarHovered(isHovered: boolean) {
    this.isSidebarHovered.next(isHovered);
  }
}
